export * from './post-objekt-art.service';
export * from './post-objekt-art.service.module';